function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M37.566 61.484a31.328 31.328 0 003.418-.823M31.845 62c1.156 0 2.297-.063 3.42-.183",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.136 54.669C15.642 52.178 7.854 42.973 7.854 31.999c0-6.442 2.69-12.27 7.033-16.492l1.636 1.59c.303.295.714.46 1.143.46.89 0 1.612-.704 1.612-1.57v-7.32c0-1.228-1.022-2.223-2.284-2.223H9.47c-.892 0-1.617.705-1.615 1.573 0 .416.17.816.472 1.11l1.708 1.662C4.455 16.218 1 23.715 1 31.999c0 15.82 12.59 28.78 28.558 29.92",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.845 55.333a24.93 24.93 0 01-3.43-.236M26.124 2.516a31.314 31.314 0 00-3.418.823M31.845 2c-1.156 0-2.298.062-3.42.182",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.553 9.33C48.047 11.823 55.835 21.027 55.835 32c0 6.443-2.69 12.27-7.033 16.493l-1.633-1.588a1.64 1.64 0 00-1.142-.46c-.892-.001-1.616.703-1.616 1.571v7.317c0 1.228 1.022 2.222 2.284 2.222h7.526c.892 0 1.615-.702 1.615-1.569 0-.416-.17-.816-.473-1.112l-1.71-1.663c5.581-5.43 9.036-12.927 9.036-21.211 0-15.82-12.59-28.78-28.558-29.92",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.845 8.667c1.164 0 2.31.081 3.43.237",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M36.67 44.704a19.77 19.77 0 01-1.617.232m-5.094 0c-3.173-.328-5.459-1.252-5.459-2.342 0-.846 1.38-1.592 3.481-2.037m9.05 0c2.102.445 3.48 1.191 3.48 2.037 0 .36-.248.701-.696 1.01M36.56 36.082a44.042 44.042 0 01-2.922 3.52 1.8 1.8 0 01-2.72-.05C28.825 37.092 25 32.078 25 28.27c0-4.233 3.37-7.664 7.527-7.664 3.882 0 7.077 2.992 7.483 6.834m-1.438 5.536c.244-.447.467-.897.661-1.344m.696-2.152a8.13 8.13 0 01-.088.4",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.508 27.905c0 2.15-1.792 3.893-4.002 3.893-2.211 0-4.003-1.743-4.003-3.893 0-2.15 1.792-3.893 4.003-3.893",
  stroke: "#4D4D4D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgDevAPunto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default __webpack_public_path__ + "/img/dev-a-punto.svg";
export { SvgDevAPunto as ReactComponent };